import OveraskImpl from './overask.js';
import MojitoCore from 'mojito/core';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * Overask.
 *
 * @class Overask
 * @name module
 * @memberof Mojito.Modules.Overask
 */

export default UIControllerView('Overask', OveraskImpl);
